import { customType } from 'drizzle-orm/sqlite-core'
import { z } from 'zod'

export enum AspectRatio {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
  Square = 'square'
}

export const aspectRatioSchema = z.enum([AspectRatio.Horizontal, AspectRatio.Vertical, AspectRatio.Square])

export const aspectRatioType = customType<{ data: AspectRatio, notNull: true, default: true }>({
  dataType() {
    return 'text'
  },
  fromDriver(value) {
    const parsed = aspectRatioSchema.safeParse(value)
    if (!parsed.success) {
      throw new Error(`Invalid aspect ratio: ${value}`)
    }
    return parsed.data
  }
})
